// extracted by mini-css-extract-plugin
module.exports = {"friend":"Friend_friend__mO325","avatar":"Friend_avatar__1kdK4"};